import { PropsWithChildren, ReactElement } from "react";
import { type FlexProps } from "@ui-kit/layout/Flex/Flex.web";
import { IconComponentKeys } from "@ui-kit/icons/Icon.web";

// add new color variants here
export enum BannerVariant {
  Success = "success",
  Warning = "warning",
  Error = "error",
  Info = "info",
  DarkBlue = "dark-blue",
}

export type BannerVariantType =
  | BannerVariant.Error
  | BannerVariant.Success
  | BannerVariant.Warning
  | BannerVariant.Info
  | BannerVariant.DarkBlue
  | `${BannerVariant}`;

export type BannerSharedProps = FlexProps &
  PropsWithChildren<{
    // Enter any props that are shared from web/native
    // If the component has no children, remove the `PropsWithChildren` type
    message: string | ReactElement;
    isRounded?: boolean;
    variant?: BannerVariantType;
    bgColor?: string;
    color?: string;
    icon?: IconComponentKeys;
  }>;
